import React, { useState, useEffect } from "react";
import { Checkbox, InputLabel } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "../styles/pages/TemplateManager.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Tooltip from "@mui/material/Tooltip";

const iconComponent = (props) => {
  return <ExpandMoreIcon className={props.className} />;
};

function isSizeInArray(size, selectedSizes) {
  if (!size || typeof size !== "string" || selectedSizes.length === 0)
    return false;
  const sizeParts = size.split("×").map((item) => Number(item));
  const sortedSize = sizeParts.sort((a, b) => a - b).join("×");
  return selectedSizes.some((s) => {
    if (!s || typeof s !== "string") return false;
    const sParts = s.split("×").map((item) => Number(item));
    if (sParts.some(isNaN)) {
      console.error(`Invalid array size format: ${s}`);
      return false;
    }

    const sortedS = sParts.sort((a, b) => a - b).join("×");
    return sortedS === sortedSize;
  });
}

const SizeDropdown = (props) => {
  const [options, setOptions] = useState({});
  const [selectedValues, setSelectedValues] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const labelId = `${options?.name || "size-dropdown"}-label`;

  const handleChange = (event) => {
    options.handleChange(event);
    const value = event.target.value;
    let final = [];
    if (selectedValues.includes(value)) {
      final = selectedValues.filter((item) => {
        return item !== value;
      });
    } else {
      final = [...value];
    }
    setSelectedValues(final);
  };

  const handleLabelClick = () => {
    if (!options.disabled) {
      setIsOpen(true);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSelectOpen = () => {
    setIsOpen(true);
    if (options.onOpen) {
      options.onOpen();
    }
  };

  useEffect(() => {
    setOptions(props.options || {});
  }, [props.options]);

  return (
    <FormControl
      className="tempInputField select-with-padding "
      variant="standard"
      fullWidth={true}
    >
      <InputLabel
        htmlFor={options.name}
        id={labelId}
        onClick={handleLabelClick}
        style={{ cursor: "pointer" }}
      >
        {options.label}
      </InputLabel>
      <Select
        labelId={labelId}
        value={selectedValues}
        multiple
        open={isOpen}
        onClose={handleClose}
        onChange={handleChange}
        renderValue={(selected) => (
          <Tooltip
            title={selected.length ? selected.join(", ") : "Select Sizes"}
          >
            <span>
              {selected.length ? selected.join(", ") : "Select Sizes"}
            </span>
          </Tooltip>
        )}
        onOpen={handleSelectOpen}
        disabled={options.disabled}
        label={options.label}
        name={options.name}
        id={options.name}
        MenuProps={{
          variant: "menu",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          PaperProps: {
            style: {
              maxWidth: props.menuWidth,
              marginTop: 4,
            },
          },
          getContentAnchorEl: null,
          disableAutoFocusItem: true,
        }}
        IconComponent={iconComponent}
      >
        {options.items &&
          options.items.length > 0 &&
          options.items.map((item) => {
            const isDisabled = isSizeInArray(item, options.selectedItems);
            return (
              <MenuItem
                value={item}
                id={item}
                key={item}
                disabled={isDisabled}
                className={`menu-items ${
                  item === props.options.value
                    ? "blue-background"
                    : "no-blue-background"
                }`}
                style={{
                  paddingRight: "10px",
                  paddingLeft: "6px",
                  paddingRight: "6px",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }}
              >
                <Checkbox checked={selectedValues.includes(item)} />
                <span>{item} </span>
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
};

export default SizeDropdown;
